import { render, staticRenderFns } from "./goal-copy.vue?vue&type=template&id=20d85460&"
import script from "./goal-copy.vue?vue&type=script&lang=ts&"
export * from "./goal-copy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports